import { Injectable, EventEmitter} from '@angular/core';

export interface IToastr {
	message: string;
	type: string;
}

@Injectable()
export class toastrService {

	public readonly newNotification: EventEmitter<any>;

	static _() {
		return new toastrService();
	}

	constructor() {
		this.newNotification = new EventEmitter();
	}

	public info(message: string){
		const notif: IToastr = {message: message, type: 'toast-info' };
		this.newNotification.next(notif);
	}
	public success(message: string){
		const notif: IToastr = {message: message, type: 'toast-success' };
		this.newNotification.next(notif);
	}

	public warning(message: string){
		const notif: IToastr = {message: message, type: 'toast-warning' };
		this.newNotification.next(notif);
	}

	public error(message: string){
		const notif: IToastr = {message: message, type: 'toast-error' };
		this.newNotification.next(notif);
	}
}
